import React from "react";

// When a chunk genuinely can't load (e.g. right after a new deploy rotates
// the build hashes), React re-throws it as a render error, not a promise
// rejection — so the `unhandledrejection` reload in index.js never fires and,
// with no boundary here, React unmounts the tree to a blank white screen.
// Same sessionStorage guard/key as index.js so the two mechanisms share one
// reload budget instead of double-reloading.
const CHUNK_RELOAD_KEY = "__chunk_reload__";

class ChunkErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    const isChunkError =
      error?.name === "ChunkLoadError" ||
      error?.message?.includes("Loading chunk") ||
      error?.message?.includes("Loading CSS chunk") ||
      error?.message?.includes("Unexpected token '<'");

    if (isChunkError && !sessionStorage.getItem(CHUNK_RELOAD_KEY)) {
      sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            textAlign: "center",
            padding: 24,
            gap: 12,
          }}
        >
          <p style={{ margin: 0, fontSize: 16 }}>
            Something went wrong. Please refresh the page.
          </p>
          <button
            className="btn btn-primary"
            onClick={() => window.location.reload()}
          >
            Refresh
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ChunkErrorBoundary;
